import { Container, Spinner } from 'reactstrap';
import { useParams } from 'react-router-dom';
import useAppointmentDetail from '../hooks/useAppointmentDetail';
import { components } from '../../../Api/types/openapi';

type LegalConsulationResponse = components['schemas']['LegalConsulationResponse'];

const Detail = () => {
  const { id } = useParams<{ id: string }>();
  const appointmentId = id ? parseInt(id) : null;
  const { appointment, isLoading, error } = useAppointmentDetail(appointmentId);

  const formatDate = (date: string) => {
    return new Date(date).toLocaleDateString('es-ES');
  };

  const formatTime = (time: string) => {
    return time.substring(0, 5);
  };

  const getStatusLabel = (status: string | null) => {
    switch (status) {
      case 'P':
        return 'Pendiente';
      case 'C':
        return 'Cancelada';
      case 'R':
        return 'Reagendada';
      case 'S':
        return 'Realizada';
      default:
        return status || '-';
    }
  };

  if (isLoading) {
    return (
      <div className="page-body">
        <Container fluid>
          <div className="text-center py-5">
            <Spinner color="primary" />
          </div>
        </Container>
      </div>
    );
  }

  if (error) {
    return (
      <div className="page-body">
        <Container fluid>
          <div>Error: {error.message}</div>
        </Container>
      </div>
    );
  }

  if (!appointment) {
    return (
      <div className="page-body">
        <Container fluid>
          <div>No se encontró la cita</div>
        </Container>
      </div>
    );
  }

  return (
    <div className="page-body">
      <Container fluid>
        <div>
          <div><strong>ID:</strong> {appointment.id || '-'}</div>
          <div><strong>Fecha:</strong> {formatDate(appointment.consultation_date)}</div>
          <div><strong>Hora:</strong> {formatTime(appointment.init_consultation_time)} - {formatTime(appointment.end_consultation_time)}</div>
          <div><strong>Estado:</strong> {getStatusLabel(appointment.status)}</div>
          <div><strong>Cliente:</strong> {appointment.client?.name || appointment.client?.email || '-'}</div>
          {appointment.lawyer && (
            <div><strong>Abogado:</strong> {appointment.lawyer.name || appointment.lawyer.email || '-'}</div>
          )}
        </div>
      </Container>
    </div>
  );
};

export default Detail;

